import { getConverter } from './convertersRegistry'
import { atomicStylePropsConverterMap } from '../atomics/atomicPropsToCss'

/**
 * Helper function to ensure string result from converter.
 * Used throughout the converter system to handle the union type returned by getConverter.
 */
export const getStringFromConverter = (converterResult: string | Record<string, any>): string => {
	return typeof converterResult === 'string' ? converterResult : ''
}

/**
 * Generic utility to get a string result from any converter type.
 * This replaces the need for individual wrapper functions.
 */
export const getConverterString = (type: string, prop: any, spx?: any): string => {
	const converter = getConverter(type)
	return converter ? getStringFromConverter(converter(prop, spx)) : ''
}

/**
 * Convenience utilities for the most commonly used converters.
 * These directly use the atomic converters to avoid circular dependencies.
 */
export const getKeywordString = (prop: any): string => atomicStylePropsConverterMap.Keyword(prop)
export const getLengthString = (prop: any): string => atomicStylePropsConverterMap.Length(prop)
export const getPercentageString = (prop: any): string => atomicStylePropsConverterMap.Percentage(prop)
export const getNumberString = (prop: any): string => atomicStylePropsConverterMap.Number(prop)
export const getKeywordsString = (prop: any): string => atomicStylePropsConverterMap.Keywords(prop)
